var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSpiral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5714 23.5008C23.4153 23.5008 23.2592 23.4893 23.1031 23.4604C17.708 22.4833 11.4976 20.6447 5.61108 18.2858C4.27533 17.7481 3.62769 16.2391 4.16546 14.9036C4.70323 13.568 6.21246 12.9205 7.54821 13.4582C13.1167 15.6899 18.9686 17.4243 24.0283 18.3436C25.445 18.598 26.3817 19.9509 26.1273 21.3674C25.9018 22.622 24.8089 23.5008 23.5714 23.5008Z",
    fill: "#0AA7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3746 13.3089C23.311 13.3089 23.2532 13.3089 23.1896 13.3032C14.4233 12.6903 7.4786 11.7132 1.96212 10.3141C0.568548 9.96138 -0.275692 8.54489 0.0828209 7.15152C0.435552 5.75815 1.85226 4.91981 3.24583 5.27249C8.45584 6.59648 15.0999 7.52732 23.5539 8.11705C24.9879 8.21534 26.0692 9.45838 25.9709 10.8922C25.8726 12.2625 24.7277 13.3089 23.3746 13.3089Z",
    fill: "#0AA7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43118 10.5164C3.59273 10.5164 2.82366 10.4701 2.17024 10.3603C0.753535 10.1232 -0.200572 8.77611 0.0365087 7.35962C0.27359 5.94312 1.62091 4.98916 3.03761 5.2262C4.39071 5.45747 7.91801 5.2898 13.7525 4.14504C18.2282 3.26624 22.5534 2.081 24.2766 1.25423C25.5719 0.635601 27.1274 1.18485 27.7461 2.47994C28.3648 3.77502 27.8155 5.33027 26.5202 5.9489C23.9239 7.19195 18.5578 8.4986 14.7529 9.25021C12.1161 9.77055 7.74454 10.5164 4.43118 10.5164Z",
    fill: "url(#paint0_linear_0_86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2254 26.7287C9.84343 26.7287 8.6985 25.6475 8.62911 24.2541C8.55972 22.8203 9.66417 21.6004 11.104 21.531C15.4119 21.3228 19.1879 20.3458 22.322 18.6228C23.5826 17.929 25.1612 18.3916 25.8551 19.652C26.549 20.9124 26.0864 22.4907 24.8258 23.1845C20.992 25.289 16.4586 26.48 11.3527 26.7287C11.3064 26.7287 11.2659 26.7287 11.2254 26.7287Z",
    fill: "url(#paint1_linear_0_86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58208 18.4779C5.25211 18.4779 4.11875 17.4661 3.99153 16.1132C3.85853 14.6851 4.91094 13.4132 6.345 13.286C13.4516 12.6327 16.9558 11.2624 22.1196 8.42944C23.3801 7.74143 24.9588 8.19818 25.6527 9.45857C26.3408 10.719 25.884 12.2973 24.6234 12.9911C21.9461 14.4597 19.5926 15.6276 16.817 16.541C13.9316 17.4892 10.757 18.1021 6.82494 18.4663C6.74399 18.4721 6.66303 18.4779 6.58208 18.4779Z",
    fill: "url(#paint2_linear_0_86)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_86",
    x1: 0.0126219,
    y1: 5.69811,
    x2: 27.9763,
    y2: 5.94622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09A7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_86",
    x1: 8.63369,
    y1: 22.4612,
    x2: 26.1634,
    y2: 22.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09A7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_86",
    x1: 3.98982,
    y1: 13.2282,
    x2: 25.9547,
    y2: 13.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09A7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC0EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.224976)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpiral);
export default __webpack_public_path__ + "static/media/logo-spiral.990cf1db054b1da1110704740636f4a6.svg";
export { ForwardRef as ReactComponent };